export enum ManageIndicesStatus {
  Completed = 'Completed',
  InProgress = 'In Progress',
  Failed = 'Failed',
  InQueue = 'InQueue',
  InRetryQueue = 'InRetryQueue',
  Retrying = 'Retrying',
}
export interface IAIInvestigateTranscriptListResponse {
  totalCount: number;
  transcriptItems: IAIInvestigateTranscriptListItem[];
}

export interface ICreateTranscriptPayload {
  transcriptName: string;
  description: string;
  indexId: number;
}

export interface ICreateTranscriptResponse {
  transcriptId: number;
  transcriptName: string;
  description: string;
  indexId: number;
  indexTotalDocumentCount: number;
  ownerName: string;
  createdDate: string;
  updatedDate: string;
}

export interface IUpdateTranscriptPayload {
  transcriptName: string;
  description: string;
}

export interface IUpdateTranscriptResponse {
  transcriptId: number;
  transcriptName: string;
  description: string;
  indexId: number;
  createdDate?: string;
  updatedDate?: string;
}

export interface ISelectedTranscript {
  transcriptId: number;
  isOwner: boolean;
  indexId: number;
  indexName: string;
  isActiveIndex: boolean;
  transcriptName: string;
  ownerName: string;
  isNew?: boolean;
  documentCount?: number;
}

export interface IAIInvestigateTranscriptListItem {
  transcriptId: number;
  transcriptName: string;
  description: string;
  indexID: number;
  indexName: string;
  indexDocumentCount: number;
  ownerName: string;
  isMyTranscript: boolean;
  createdDate: string;
  updatedDate: string;
}

export interface IColumnFilter {
  columnName?: string;
  value?: string;
}

export interface IAIInvestigateTranscriptPayload {
  isMyTranscript?: boolean | null;
  simpleFilterText?: string;
  sortingColumn?: string;
  direction?: string;
  displayLength: number;
  pageNumber: number;
  columnFilter?: IColumnFilter[];
}

export interface IIndicesColumnFilter {
  columnName: string;
  value: string;
}

export interface IAIInvestigateIndicesPayload {
  sortingColumn: string;
  direction: string;
  displayLength?: number;
  pageNumber?: number;
  columnFilter: IIndicesColumnFilter[];
  isActiveOnly?: boolean;
}

export interface IAIInvestigateIndicesListResponse {
  totalRecords: number;
  indices: IAIInvestigateIndicesListItem[];
}

export interface IAIInvestigateIndicesListItem {
  indexId: string;
  indexName: string;
  updatedBy: string;
  action: string;
  totalDocs: number;
  lastModifiedDate: string;
  status: string;
  indexStatus: string;
}

export interface ICreateIndexPayload {
  indexName: string;
  sourceIds: string[];
  emailIdsToNotify: string[];
  sourceTypeCode: 'SAVEDSEARCH' | 'TAG' | 'FOLDER';
}
export interface ICreateIndexResponse {
  indexId: string;
  indexName: string;
  sourceTypeCode: 'SAVEDSEARCH' | 'TAG' | 'FOLDER';
  actionType: string;
  status: boolean;
}

export interface IDeleteTranscriptResponse {
  transcriptId: number;
  status: string;
  message: string;
}

export interface IAIInvestigateOwnersListResponse {
  userId: number;
  ownerName: string;
}

export interface IAIInvestigateTranscriptFollowUpQuestion {
  number: number;
  question: string;
}

export interface IAIInvestigateConversationItem {
  conversationId: number;
  conversationNumber: number;
  question: string;
  questionDateTime: string;
  answer: string;
  isDeleted: boolean;
  transcriptId: number;
  followUpQuestions: IAIInvestigateTranscriptFollowUpQuestion[];
}
export interface ICreateConversationPayload {
  question: string;
}

export interface ICreateConversationResponse {
  conversationId: number;
  conversationNumber: number | null;
  question: string;
  questionDateTime: string;
  answer: string;
  isDeleted: boolean;
  transcriptId: number;
  followUpQuestions: IAIInvestigateTranscriptFollowUpQuestion[];
}

export interface IAIInvestigateTranscriptDetailsResponse {
  transcriptId: number;
  transcriptName: string;
  indexId: number;
  indexName: string;
  isIndexActive: boolean;
  documentCount: number;
  userId: number;
  projectId: number;
  totalConversationCount: number;
  latestConversationNumber: number;
  conversations: IAIInvestigateConversationItem[];
  latestConversationFollowUpQuestions: IAIInvestigateTranscriptFollowUpQuestion[];
  createdDate: string;
  updatedDate: string;
  followUpQuestions: {
    number: number;
    question: string;
  }[];
}
export interface IToggleIndexPayload {
  status: boolean;
}

export interface IToggleIndexResponse {
  statusCode: number;
}

export type ToggleIndexParams = {
  indexId: number | string;
  payload: IToggleIndexPayload;
};

export interface IRetryInvestigateIndexResponse {
  indexId: number;
  indexDetailsId: number;
  updatedBy: string;
  lastModifiedDate: string;
  status: string;
}

export type RetryInvestigateIndexParams = {
  indexId: number | string;
  indexDetailsId: number | string;
};

export interface IGetDownloadDocumentResponse {
  blob: Blob;
  filename: string;
  contentDisposition?: string;
}
export interface IAIInvestigateIndicesDetailsPayload {
  sortingColumn: string;
  direction: string;
  displayLength: number;
  pageNumber: number;
  columnFilter: IIndicesColumnFilter[];
}

export interface IAIInvestigateConversationDocumentDetailsPayload {
  sortingColumn: string;
  direction: string;
  displayLength: number;
  pageNumber: number;
}

export interface IAIInvestigateConversationDocumentDetailItem {
  documentId: number;
  docId: string;
  summary: string;
  similarityScore: number;
}

export interface IAIInvestigateConversationDocumentDetailsResponse {
  totalRecords: number;
  documentDetails: IAIInvestigateConversationDocumentDetailItem[];
}

export interface IAIInvestigateIndicesDetailsResponse {
  documentCount: number;
  totalRecords: number;
  indexDetails: IAIInvestigateIndexDetails[];
}

export interface IAIInvestigateIndexDetails {
  indexId: number;
  indexDetailId: number;
  indexName: string;
  dateSubmitted: string;
  source: string;
  updatedBy: string;
  action: string;
  includedDocCount: number;
  excludedDocCount: number;
  lastModifiedDate: string;
  status: string;
}

export interface ISavedSearch {
  id: string;
  text: string;
  parent: string;
  isGroup: boolean;
  type: string;
  searchGroupTypeCode: string;
  a_attr: string;
  isSelected: boolean;
  state: {
    disabled: boolean;
    selected: boolean;
    opened: boolean;
  };
  li_attr: {
    isCascadeEnabled: boolean;
  };
  saveSearchSecurityGroupId: number;
  documentCount: number;
  textWithoutCount: string;
}

export interface IEditIndexPayload {
  indexName: string;
  sourceIds: string[];
  emailIdsToNotify: string[];
  sourceTypeCode: 'SAVEDSEARCH' | 'TAG' | 'FOLDER';
  action: 'ADD' | 'REMOVE';
}

export interface IAIInvestigateDocumentSummaryResponse {
  documentId: number;
  summary: string;
}

export type IAIInvestigateIndexSourceTypeCode =
  | 'SAVEDSEARCH'
  | 'TAG'
  | 'FOLDER';

export interface IIndexSourceDocumentCountPayload {
  sourceTypeCode: IAIInvestigateIndexSourceTypeCode;
  sourceIds: string[];
}

export interface IIndexSourceDocumentCountResponse {
  documentCount: number;
}

/** POST /ai/api/v1/investigate/navigation-master-list */
export interface IInvestigateNavigationMasterListPayload {
  destinationTypeCode: string;
  isInverse: boolean;
  selectedDocIDs: string;
  excludedDocIDs: string;
  selectedConversationID: number;
  documentCount: number;
}

export interface IInvestigateNavigationMasterListResponse {
  doclistMasterId: string;
}

export type ManageIndexRow = {
  id: number;
  indexName: string;
  updatedBy: string;
  indexId: string;
  active: boolean;
  totalDocs: number;
  lastModifiedUtc: string;
  indexStatus: string;
};
export interface IIndexDetailsDataUpdatedNotification {
  indexDetailID: number;
  includedDocCount: number;
  excludedDocCount: number;
  status: ManageIndicesStatus;
  documentCount: number;
  createdAt: string;
}
export interface ManageIndexDataUpdatedNotification {
  indexId: number;
  totalDocs: number;
  indexStatus: string;
  createdAt: string;
}
